
export { GGUSection } from "/codebuild/output/src2315228166/src/packages/shared-components/src/campaign/GGUSection.tsx"